import BasicService from "./BasicService";

class OrderService extends BasicService {
  constructor() {
    super();
  }

  /**
   *
   * @param {Object} order - {"itemId": Number,"fromBranchDto": {"branchId": Number},"toBranchDto": {"branchId": Number},"osDto": {"osId": Number },"townshipDto": {"townshipId": Number}, "code": String,"customerName": String,"address": String,"phone": String,"requestDate": "DD-MM-YYYY"}
   */
  saveOrderService(order) {
    let url = `/orders`;
    return this.axios.post(url, order).then(response => response.data);
  }
  saveOrderPhoto(formData,itemId){
    let url = `/orders/${itemId}/photo`;
    return this.axios.post(url, formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(request => request.data);
}
saveAssignedPhoto(formData,transactionId){
  let url = `/orders/transaction/${transactionId}/assigned`;
  return this.axios.post(url, formData,
      {
          headers: {
              'Content-Type': 'multipart/form-data'
          }
      }).then(request => request.data);
}
saveNotiPhoto(formData,notiId){
  let url = `/os/noti/${notiId}/photo`;
  return this.axios.post(url, formData,
      {
          headers: {
              'Content-Type': 'multipart/form-data'
          }
      }).then(request => request.data);
}
saveRiderPhoto(formData,useraccountId){
  let url = `/useraccounts/riderlogo/${useraccountId}`;
  return this.axios.post(url, formData,
      {
          headers: {
              'Content-Type': 'multipart/form-data'
          }
      }).then(request => request.data);
}
  /**
   * @param {Number} itemId
   * @param {Object} order - {"itemId": Number,"fromBranchDto": {"branchId": Number},"toBranchDto": {"branchId": Number},"osDto": {"osId": Number },"townshipDto": {"townshipId": Number}, "code": String,"customerName": String,"address": String,"phone": String,"requestDate": "DD-MM-YYYY"}
   */
  updateOrderService(itemId, order) {
    let url = `/orders/${itemId}`;
    return this.axios.put(url, order).then(response => response.data);
  }

  /**
   *
   * @param {Number} orderId - same with itemId
   */
  loadOrder(orderId) {
    let url = `/orders/${orderId}`;
    return this.axios.get(url).then(response => response.data);
  }

  /**
   *
   * @param {Number} orderId - same with itemId
   */
  getStatus(orderId) {
    let url = `/orders/${orderId}/status`;
    return this.axios.get(url).then(response => response.data);
  }

  getOrderList(type) {
    let url = `/delivery`;

    return this.axios
      .get(url, {
        params: {
          type
        }
      })
      .then(response => response.data);
  }

  getOsByOsName(itemId) {
    let url = `/delivery/os`;
    return this.axios
      .get(url, {
        params: {
          itemId
        }
      })
      .then(response => response.data);
  }

  getCustomerByItemId(itemId) {
    let url = `/delivery/customer`;
    return this.axios
      .get(url, {
        params: {
          itemId
        }
      })
      .then(response => response.data);
  }

  deleteItemById(itemId) {
    let url = `/delivery/items/${itemId}`;
    return this.axios.delete(url).then(response => response.data);
  }

  /**
   *
   * @param {Date} fromDate - dd-mm-yyyy
   * @param {Date} toDate - dd-mm-yyyy
   * @param {String} type - ALL, COMPLETE, RETURN
   * @param {String} action - Date, ModifiedDate
   */
  getCompletReturnList(fromDate, toDate, type, action) {
    let url = `/delivery/completedorreturn`;
    return this.axios
      .get(url, {
        params: {
          fromDate,
          toDate,
          type,
          action
        }
      })
      .then(response => response.data);
  }

  getOrderById(itemId) {
    let url = `/delivery`;

    return this.axios
      .get(url, {
        params: {
          itemId: itemId
        }
      })
      .then(response => response.data);
  }

  getOrderByCodeId(codeId) {
    let url = `/delivery/code`;

    return this.axios
      .get(url, {
        params: {
          codeId: codeId
        }
      })
      .then(response => response.data);
  }

  /**
   *
   * @param {Number[]} ids
   */
  getVoucherById(ids) {
    let url = `/orders/vouchers`;
    return this.axios.post(url, ids).then(response => response.data);
  }
  deleteOrderPhoto(itemId) {
    let url = `/orders/${itemId}/photo`;
    return this.axios.delete(url).then(response => response.data);
  }
  updateMainMenu(itemId) {
    let url = `/orders/${itemId}/mainmenu`;
    return this.axios.put(url).then(response => response.data);
  }
  deleteAssignPhoto(transactionId) {
    let url = `/orders/transaction/${transactionId}/assigned`;
    return this.axios.delete(url).then(response => response.data);
  }
  deleteNotiPhoto(notiId) {
    let url = `/os/noti/${notiId}/photo`;
    return this.axios.delete(url).then(response => response.data);
  }
  getfindPhone(phoneno) {
    let url = `/excels/phone`;
    return this.axios.get(url,{
      params:{
        phoneno
      }
    }).then(response => response.data);
  }
  deletePhotoSignOs(itemId) {
    let url = `/orders/${itemId}/signos`;
    return this.axios.delete(url).then(response => response.data);
  }
  deletePhotoSignCustomer(itemId) {
    let url = `/orders/${itemId}/signcust`;
    return this.axios.delete(url).then(response => response.data);
  }
  saveGateVoucher(formData,itemId){
    let url = `/orders/${itemId}/gatevoucher`;
    return this.axios.post(url, formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(request => request.data);
}
saveItemSimple(formData,itemId){
  let url = `/orders/${itemId}/itemsimple`;
  return this.axios.post(url, formData,
      {
          headers: {
              'Content-Type': 'multipart/form-data'
          }
      }).then(request => request.data);
}
riderStatusList() {
  let url = `/orders/rstatuslist`;
  return this.axios.get(url).then(response => response.data);
}
}

const orderService = new OrderService();
export default orderService;
